/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import '../PendingForReviewToll/violationforplazareviewlisting.css'
import Table from 'react-bootstrap/Table'
import { getAllRaisedCAData, getAllRaisedCADataDownload } from '../../../common/apiService'
import CommonDateRangePicker from '../../../common/daterangepicker'
import CustomPagination from '../../../common/custom_pagination'
import Loader from 'react-loader-spinner';
import Moment from 'moment'
import SelectSearch, { fuzzySearch } from "react-select-search";
import '../../../common/selectsearch.css';
import { getJsonData } from '../../../service/utilService'
import DownloadBtn from '../../../common/DownloadBtn';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { toast } from 'react-toastify';
import { FaSearch } from 'react-icons/fa';
import moment from 'moment';
import { UserContext } from '../../../contexts/UserContext';


export default function RaisedCreditAdjustmentsScreen() {
    const userDetail = useContext(UserContext);
    const [downloaddata, setDownloaddata] = useState([]);
    const [gridList, setGridList] = useState([]);
    const [jsonData, setJsonData] = useState(getJsonData(userDetail,true));
    const [totalPage, setTotalPage] = useState(0);
    const [currentPage, setCurrentPage] = useState("0");
    const [violationtype] = useState("Raised Credit Adjustments");
    const [loading, setLoading] = useState(false);
    const [viostatus, setVioStatus] = useState('All');
    const [tollplaza, setTollPlaza] = useState();
    const [tolldata, setTollData] = useState([]);
    const [totalGridData, setTotalGridData] = useState(0);
    const [loadingreport, setLoadingReport] = useState(false);
    const [searchText, setSearchText] = useState("");
    const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    let violationstatusData = [
        { name: 'All', value: 'All' },
        {name: 'Submitted', value:'Submitted'},
        { name: 'Raised with NPCI', value: 'Raised with NPCI'},
        { name: 'Settled with NPCI', value: 'Settled with NPCI'},
        { name: 'Declined by NPCI', value: 'Declined by NPCI'}
    ];
    const sortedby = '';
    const orderby = 'asc';

    useEffect(() => {
    if(userDetail?.plaza!==null && userDetail?.plaza!==""){
        const plaza = userDetail.plaza || '';
        //const plazaArr =  plaza?.split(",");
        const plazadata = [];
        for (let p of plaza) {
            const json = { name: p, value: p};
            plazadata.push(json);
        }
        setTollData(plazadata)
    }
        // eslint-disable-next-line
    }, [userDetail])

    useEffect(() => {
        setTimeout(() => setTollPlaza(userDetail.plaza),0)
    }, [userDetail])

    useEffect(() => {
        if (tollplaza)
            griddata();
        // eslint-disable-next-line
    }, [jsonData, viostatus, tollplaza])

    useEffect(() => {
        if (currentPage !== "0")
            pageChange();
        // eslint-disable-next-line
    }, [currentPage])

    const downloadfile = async () => {
        const { headerJson, bodyJson } = getJson();
        setLoadingReport(true);
        let res = await getAllRaisedCADataDownload(headerJson, bodyJson);
        if (res.data){
        const data = new Blob([res.data], { type:  "application/vnd.ms-excel;charset=UTF-8" });
        FileSaver.saveAs(data, "RaisedCreditAdj_"+moment(new Date()).format("DD/MM/YYYY hh:mm:ss A") + fileExtension);
        }
        else
          toast.warning("No Data found");
        setLoadingReport(false);
    }

    const getJson = () => {
        const headerJson = {
            status: viostatus,
            dateType: jsonData.dateType,
            startDate: jsonData.startDate.split("T")[0],
            endDate: jsonData.endDate.split("T")[0],
            searchText
        }
        const bodyJson = {
            plazaId: Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds
        }
        const paramJson = {
            offset: currentPage,
            limit: '50',
            sort_c: sortedby,   
            sort_t: orderby
        }
        const json = {
            headerJson: headerJson,
            bodyJson: bodyJson,
            paramJson: paramJson
        }
        return json;
    }

    const griddata = async () => {
        setLoading(true);
        const { headerJson, bodyJson, paramJson } = getJson();
        try{
            const res = await getAllRaisedCAData(headerJson, bodyJson, paramJson);
            const data = res.data.data;
            let cache = [];
            data.forEach((e,i)=>{
                setTimeout(()=>{
                cache.push(e);
                setGridList([...cache]);
            },50*i)})
            if(data.length===0){
                setGridList([]);
            }
            const totalpages = res.data.pages;
            setTotalPage(totalpages);
            setTotalGridData(res.data.totalElements);
            setLoading(false);
        }catch{
            setTotalPage(0);
            setTotalGridData(0);
            setLoading(false);
            setGridList([]);
        }
    }

    const pageChange = () => {
        griddata();
    }

    const gridfilter = (evt) => {
        const value = evt.target.value;
        if (evt.key === 'Enter') {
            if (value) {
                setSearchText(value.trim());
                griddata(value.trim());
                
            } else {
                setSearchText("");
                griddata(value.trim());
            }
        }
    }

    return (
        <>
            <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={100}
                width={100}
                visible={loading}
                style={{backgroundColor:'lightgrey'}} />
            <div className="container-fluid assignMakers">
                <div className="row">
                    <div className="col-md-5">
                        <h3>{violationtype}</h3>
                    </div>
                    <div className="col-md-4">
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="col-md-12">
                    <div className="row filterssrtip">
                        <div className="col-md-3">
                            <h4 className="lowh3">Raised Refunds - <span>{totalGridData}</span></h4>
                        </div>
                        <div className="col-md-9 option">
                            <DownloadBtn
                                downloaddata={downloaddata}
                                loadingreport={loadingreport}
                                downloadexcel={downloadfile}
                            />
                            <CommonDateRangePicker
                                plazaClassName="tollfilter"
                                datepickerClassName="daterange"
                                setjsonData={setJsonData}
                                showVioCreationDate
                            />
                            <div className="violationstatusfilter">
                                <SelectSearch
                                    options={violationstatusData}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="CA Status"
                                    value={viostatus}
                                    onChange={(selectedValue) => setVioStatus(selectedValue)}
                                />
                            </div>
                            <div className="searchbar">
                                <input className="form-control" onChange={e => setSearchText(e.target.value)} onKeyPress={gridfilter} placeholder="Search" />
                                {searchText ? <FaSearch onClick={() => griddata()} /> : <FaSearch />}
                            </div>
                        </div>
                    </div>
                    <div style={{ maxHeight: 600, overflowX: 'hidden', width: '100%', marginBottom: 10 }}>
                    <Table striped bordered hover variant="light" className="customTable">
                        <thead>
                                <tr className="pointer" style={{ position: 'sticky', top: -1 }}>
                                <th>RRN </th>
                                <th>Tag ID </th>
                                <th>Registration No </th>
                                <th>Transaction Time </th>
                                <th>Txn Amount</th>
                                <th>CA Raised Time</th>
                                <th>CA Amount</th>
                                <th>CA Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gridList.length>0?
                                gridList.map((e) => (
                                        <tr>
                                            <td>{e.rrn || '--'}</td>
                                            <td>{e.tagId || '--'}</td>
                                            <td>{e.regNumber || '--'}</td>
                                            <td>{e.transactionProdDtAtNPCI ? Moment.utc(e.transactionProdDtAtNPCI).format("YYYY-MM-DD, HH:mm") : '--'}</td>
                                            <td>{e.transactionAmount || '--'}</td>
                                            <td>{e.violationCreateDate ? Moment.utc(e.violationCreateDate).format("YYYY-MM-DD, HH:mm") : '--'}</td>
                                            <td>{e.differentialAmount || '--'}</td>
                                            <td>{e.status || '--'}</td>
                                        </tr>
                                    )
                                )
                            :
                            <tr>
                                <td colSpan="8" style={{ textAlign: 'center' }}>Data Not Found!</td>
                            </tr>
                            }
                        </tbody>
                    </Table>
                    </div>
                    <CustomPagination
                        currentPage={currentPage}
                        totalPage={totalPage}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            </div>
        </>
    )
}


